module.exports = __webpack_public_path__ + "static/3-9f7f12803df566273990db5f950cd4c1.jpg";